module.exports = __webpack_public_path__ + "img/sv73on.189ac8c2.svg";